export default __webpack_public_path__ + "static/media/team.e4923715.jpg";